import {
  BUCKET_COLOR_VAR,
  BUCKET_LABEL,
  type Bucket,
  type BucketedEmails,
} from "@/lib/emails";
import { cn } from "@/lib/cn";

interface MobileBucketTabsProps {
  buckets: BucketedEmails;
  active: Bucket;
  onChange: (b: Bucket) => void;
  /** Buckets shown as tabs (FYI lives in its own section below). */
  visibleBuckets: Bucket[];
}

export function MobileBucketTabs({
  buckets,
  active,
  onChange,
  visibleBuckets,
}: MobileBucketTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Email buckets"
      className="flex gap-1 overflow-x-auto rounded-lg border border-op-border bg-op-surface p-1"
      data-testid="mobile-bucket-tabs"
    >
      {visibleBuckets.map((b) => {
        const isActive = b === active;
        return (
          <button
            key={b}
            role="tab"
            aria-selected={isActive}
            type="button"
            onClick={() => onChange(b)}
            data-testid={`mobile-tab-${b}`}
            className={cn(
              "flex min-w-0 flex-1 items-center justify-center gap-2 rounded px-2 py-2 text-xs uppercase tracking-wider transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-op-accent",
              isActive
                ? "bg-op-elevated text-op-primary"
                : "text-op-secondary hover:bg-op-elevated",
            )}
          >
            <span
              aria-hidden
              className="h-1.5 w-1.5 shrink-0 rounded-full"
              style={{ backgroundColor: BUCKET_COLOR_VAR[b] }}
            />
            <span className="truncate">{BUCKET_LABEL[b]}</span>
            <span className="shrink-0 rounded-full bg-op-base/60 px-1.5 py-0.5 font-mono text-[10px] text-op-secondary">
              {buckets[b].length}
            </span>
          </button>
        );
      })}
    </div>
  );
}
